/* unplugin-vue-components disabled */import { render } from "./menu-collapsed.vue?vue&type=template&id=31dc0930&scoped=true"
import script from "./menu-collapsed.vue?vue&type=script&lang=js"
export * from "./menu-collapsed.vue?vue&type=script&lang=js"

import "./menu-collapsed.vue?vue&type=style&index=0&id=31dc0930&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dc0930"],['__file',"src/components/navbar/menu-collapsed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31dc0930"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31dc0930', __exports__)) {
    api.reload('31dc0930', __exports__)
  }
  
  module.hot.accept("./menu-collapsed.vue?vue&type=template&id=31dc0930&scoped=true", () => {
    api.rerender('31dc0930', render)
  })

}


export default __exports__